async function sha256(plain) {
    const encoder = new TextEncoder();
    const data = encoder.encode(plain);
    return window.crypto.subtle.digest("SHA-256", data);
}
function base64urlencode(a) {
    var str = "";
    var bytes = new Uint8Array(a);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        str += String.fromCharCode(bytes[i]);
    }
    return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
async function generateChallenge(code_verifier) {
    var hashed = await sha256(code_verifier);
    var base64encoded = base64urlencode(hashed);
    return base64encoded;
}
function stringQuery(object) {
    return Object.entries(object)
        .filter(([key, value]) => value && value !== "undefined" && value !== "null")
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");
}
function randomToken(length) {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.";
    const randomIdxs = window.crypto.getRandomValues(new Uint8Array(length));
    let token = "";
    randomIdxs.forEach((idx) => (token += characters[idx % characters.length]));
    return token;
}
function parseJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(window
        .atob(base64)
        .split("")
        .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(""));
    return JSON.parse(jsonPayload);
}

class FirstlineClient {
    constructor(options) {
        this.options = options;
        this.serverUrl = options.domain.includes("localhost")
            ? `http://${options.domain}`
            : `https://${options.domain}`;
    }
    async loginRedirect(options) {
        var _a, _b, _c;
        const code_verifier = randomToken(43);
        const authorizeQueryParams = {
            grant_type: "authorization_code",
            response_type: "code",
            response_mode: "query",
            audience: this.options.audience,
            client_id: this.options.client_id,
            redirect_uri: (_a = options === null || options === void 0 ? void 0 : options.redirect_uri) !== null && _a !== void 0 ? _a : this.options.redirect_uri,
            state: (_b = options === null || options === void 0 ? void 0 : options.state) !== null && _b !== void 0 ? _b : randomToken(64),
            code_challenge: await generateChallenge(code_verifier),
            action_hint: (_c = options === null || options === void 0 ? void 0 : options.action_hint) !== null && _c !== void 0 ? _c : "login",
        };
        const query = stringQuery(authorizeQueryParams);
        window.localStorage.setItem("state", authorizeQueryParams.state);
        window.localStorage.setItem("code_verifier", code_verifier);
        window.location["assign"](`${this.serverUrl}/api/v3/authorize?${query}`);
    }
    async verifyRedirect() {
        window.location["assign"](`${this.serverUrl}/ui/mail-confirmation?redirect_uri=${encodeURIComponent(this.options.redirect_uri)}`);
    }
    async exchangeAuthorizationCode(authorizationCode, code_verifier, state) {
        const exchangeTokenRequest = {
            grant_type: "authorization_code",
            code: authorizationCode,
            client_id: this.options.client_id,
            code_verifier: code_verifier,
            redirect_uri: this.options.redirect_uri,
            state: state,
        };
        const exchangeTokenParams = stringQuery(exchangeTokenRequest);
        const token_response = await fetch(`${this.serverUrl}/api/v3/oauth/token?${exchangeTokenParams}`, {
            method: "post",
        }).then((response) => response.json());
        return token_response;
    }
    async exchangeRefreshToken(refreshToken) {
        const exchangeTokenRequest = {
            grant_type: "refresh_token",
            refresh_token: refreshToken,
            client_id: this.options.client_id,
        };
        const exchangeTokenParams = stringQuery(exchangeTokenRequest);
        const token_response = await fetch(`${this.serverUrl}/api/v3/oauth/token?${exchangeTokenParams}`, {
            method: "post",
        }).then((response) => response.json());
        return token_response;
    }
    async logout() {
        var _a;
        window.localStorage.removeItem("refresh_token");
        const logoutRequest = {
            client_id: this.options.client_id,
            logout_uri: (_a = this.options.logout_uri) !== null && _a !== void 0 ? _a : this.options.redirect_uri,
        };
        const logoutParams = stringQuery(logoutRequest);
        window.location["assign"](`${this.serverUrl}/api/v3/logout?${logoutParams}`);
    }
    async doExchangeCode() {
        const params = new URLSearchParams(window.location.search);
        const codeParam = params.get("code");
        const stateParam = params.get("state");
        const storedState = window.localStorage.getItem("state");
        const storedCodeVerifier = window.localStorage.getItem("code_verifier");
        if (codeParam && stateParam && storedState && storedCodeVerifier) {
            if (stateParam === storedState) {
                const tokenResponse = await this.exchangeAuthorizationCode(codeParam, storedCodeVerifier, stateParam);
                window.localStorage.removeItem("state");
                window.localStorage.removeItem("code_verifier");
                window.localStorage.setItem("refresh_token", tokenResponse.refresh_token);
                window.history.pushState("object or string", "Title", "/" +
                    window.location.href
                        .substring(window.location.href.lastIndexOf("/") + 1)
                        .split("?")[0]);
                return tokenResponse;
            }
        }
        return null;
    }
    async doRefresh() {
        const refresh_token = window.localStorage.getItem("refresh_token");
        if (refresh_token) {
            const tokenResponse = await this.exchangeRefreshToken(refresh_token);
            if (tokenResponse.refresh_token) {
                window.localStorage.setItem("refresh_token", tokenResponse.refresh_token);
                return tokenResponse;
            }
            else {
                window.localStorage.removeItem("refresh_token");
            }
        }
        return null;
    }
    async doExchangeOrRefresh() {
        let tokens = await this.doRefresh();
        if (!tokens)
            tokens = await this.doExchangeCode();
        return tokens;
    }
    getUser(tokens) {
        if (tokens === null || tokens === void 0 ? void 0 : tokens.id_token) {
            return parseJwt(tokens.id_token);
        }
        return null;
    }
    isEmailVerified(tokens) {
        const userObject = this.getUser(tokens);
        return userObject.is_verified ? true : false;
    }
}

export { FirstlineClient };
//# sourceMappingURL=firstline-spa-js.esm.js.map
